module.exports = __webpack_public_path__ + "static/media/canvas_summary_active.a9e491cf.svg";